import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { Offer, Reward } from "@obg/ngx.common";

@Component({
	selector: "obg-m-deposit-bonus-item",
	templateUrl: "./deposit-bonus.component.html",
	styleUrls: ["./deposit-bonus.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepositBonusComponent {
	@HostBinding("class.obg-m-deposit-bonus-item") hostCssClass = true;

	@Input() item: Offer | Reward | undefined;

	@Output() getBonus = new EventEmitter();
}
